interface Props {
  total: number;
  current: number; // zero-based
}

export default function ProgressDots({ total, current }: Props) {
  return (
    <div className="progress" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={current + 1}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={"progress__dot" + (i === current ? " progress__dot--active" : "")}
        />
      ))}
    </div>
  );
}
